import useIsMobile from "../hooks/useIsMobile";

import "./CasePage.css";
import { motion, AnimatePresence } from "framer-motion";

import caseIcon from "../imgs/caseIcon.svg";
import caseIcon2 from "../imgs/caseIcon2.svg";
import caseIcon3 from "../imgs/caseIcon3.svg";
import caseIcon4 from "../imgs/caseIcon4.svg";
import caseIcon41 from "../imgs/caseIcon41.svg";
import caseIcon5 from "../imgs/caseIcon5.svg";
import caseIcon6 from "../imgs/caseIcon6.svg";
import caseIcon7 from "../imgs/caseIcon7.svg";
import caseIcon8 from "../imgs/caseIcon8.svg";
import caseIcon9 from "../imgs/caseIcon9.svg";
import caseIcon10 from "../imgs/market.svg";

import moreTop from "../imgs/moreTop.svg";
import moreFooter from "../imgs/moreFooter.svg";

import { useState, useEffect, useRef } from "react";

export const openTalk = () => {
  window.open("https://form.typeform.com/to/lduiliob", "_blank");
};

const projects = [
  {
    name: "Euler Finance",
    link: "https://blog.brevis.network/2025/06/30/incentra-launches-with-euler-campaigns-on-arbitrum-trustless-incentive-infrastructure-for-sustained-defi-growth/",
  },
  {
    name: "QuickSwap",
    link: "https://x.com/QuickswapDEX/status/1947972378367070555",
  },
  {
    name: "THENA",
    link: "https://blog.brevis.network/2024/12/12/thena-partners-with-brevis-to-launch-intelligent-dex-features/",
  },
  {
    name: "Algebra Labs",
    link: "https://medium.com/@crypto_algebra/algebra-joins-forces-with-brevis-new-integral-plugin-utilizing-the-zk-coprocessor-4cc82712f2e5",
  },
  {
    name: "Beefy",
    link: "https://blog.brevis.network/2025/09/15/beefy-%f0%9f%a4%9d-brevis-zk-powered-yield-optimization/",
  },
  {
    name: "BeraBorrow",
    link: "https://blog.brevis.network/2025/02/21/brevis-and-beraborrow-are-bringing-continuous-protocol-incentivization-to-berachain/",
  },
  {
    name: "Aave",
    link: "https://blog.brevis.network/2025/08/13/setting-a-new-standard-for-on-chain-incentives-with-metamask-linea-and-brevis/",
  },
  {
    name: "Kwenta",
    link: "https://blog.brevis.network/2024/09/09/kwenta-launches-zk-powered-trader-loyalty-program-enabled-by-brevis/",
  },
  {
    name: "JOJO Exchange",
    link: "https://cryptobriefing.com/jojo-zk-proofs-technology/",
  },
  {
    name: "Bedrock",
    link: "https://blog.brevis.network/2025/09/05/bedrock-x-brevis-rethinking-incentives-in-liquid-restaking/",
  },
  {
    name: "Mellow",
    link: "https://blog.brevis.network/2025/01/15/mellow-and-brevis-exploring-trustless-loyalty/",
  },
  {
    name: "Turtle",
    link: "https://blog.brevis.network/2025/09/02/linea-boosts-growth-with-brevis-zk-powered-linea-ignition-program/",
  },
  {
    name: "Lista",
    link: "https://blog.brevis.network/2025/10/17/proving-grounds-partner-lista/",
  },
  {
    name: "KoalaSwap",
    link: "https://blog.brevis.network/2025/10/27/koalaswap-launches-2m-rewkoala-lp-rewards-on-unit-zero-powered-by-brevis-incentra/",
  },
  {
    name: "Cypher",
    link: "https://x.com/brevis_zk/status/2011030479399764448",
  },
  {
    name: "Mendi Finance",
    link: "https://blog.brevis.network/2024/12/20/brevis-partners-with-mendi-to-pioneer-intelligent-lending-solutions/",
  },
  {
    name: "Aperture",
    link: "https://blog.brevis.network/2024/04/22/the-new-frontier-of-autonomous-intent-centric-defi-the-partnership-between-brevis-and-aperture/",
  },
  {
    name: "TermMax",
    link: "https://x.com/brevis_zk/status/2018655716022612269",
  },
];

const aiProjects = [
  {
    name: "Pieverse",
    link: "https://x.com/pieverse_io/status/1984093439194231033",
  },
  {
    name: "Vana",
    link: "https://blog.brevis.network/2025/11/04/brevis-x-vana-enabling-private-data-sovereignty-with-zk-powered-trust/",
  },
  {
    name: "UnifAI",
    link: "https://x.com/brevis_zk/status/1984949083048751239",
  },
  {
    name: "Camp Network",
    link: "https://blog.brevis.network/2026/03/31/brevis-and-camp-network-verifiable-ip-for-the-ai-era/",
  },
];

const rwaProjects = [
  {
    name: "YieldNest",
    link: "https://blog.brevis.network/2025/11/18/yieldnest-launches-incentra-campaign-for-ynrwax-holders/",
  },
  {
    name: "USD8",
    link: "https://blog.brevis.network/2026/01/20/brevis-and-usd8-trustless-insurance-for-defi/",
  },
  {
    name: "Matrixdock",
    link: "https://blog.brevis.network/2026/02/27/matrixdock-launches-dual-reward-gold-lp-campaign-on-pancakeswap-with-incentra/",
  },
];

const linkJson = {
  PancakeSwap:
    "https://blog.brevis.network/2025/05/12/hook-into-the-future-intelligent-ux-on-pancakeswap-infinity-powered-by-brevis/",
  Uniswap:
    "https://blog.brevis.network/2025/10/24/uniswap-foundation-awards-brevis-grant-for-trustless-routing-rebate-program-up-to-9m/",
  MetaMask:
    "https://blog.brevis.network/2025/08/13/setting-a-new-standard-for-on-chain-incentives-with-metamask-linea-and-brevis/",
  OpenEden:
    "https://blog.brevis.network/2025/07/10/brevis-and-openeden-teaming-up-trustless-zk-powered-rewards-are-coming/",
  UsualMoney:
    "https://blog.brevis.network/2024/11/08/say-bye-to-airdrops-say-hi-to-continuous-rewards-how-brevis-and-usual-are-changing-protocol-incentivization-design/",
  MetaMaskUSD: "https://x.com/brevis_zk/status/1955614853357596995",
  Kernel:
    "https://blog.brevis.network/2025/01/23/brevis-and-kernel-enable-cross-chain-restaking-to-expand-bnb-restaked-security/",
  Celer: "https://celer.network/",
  Linea:
    "https://blog.brevis.network/2025/09/02/linea-boosts-growth-with-brevis-zk-powered-linea-ignition-program/",
  TAC: "https://blog.brevis.network/2025/08/25/brevis-now-live-on-tac-enabling-lightning-fast-trustless-and-gas-efficient-defi-for-global-users/",
  UnitsNetwork: "https://x.com/UnitsNetwork/status/1982787835670266061",
  GG: "https://blog.brevis.network/2024/06/17/0g-and-brevis-partner-to-enable-trust-free-cross-chain-da/",
  Ethereum:
    "https://blog.brevis.network/2025/10/15/pico-prism-99-6-real-time-proving-for-45m-gas-ethereum-blocks-on-consumer-hardware/",
  Kaito:
    "https://blog.brevis.network/2025/09/23/brevis-yapper-leaderboard-launches-on-kaito-privacy-preserving-infofi/",
  Trust: "https://x.com/brevis_zk/status/1891883192086634516",
  KiteAI: "https://x.com/GoKiteAI/status/1980919102756827321",
  Pieverse: "https://x.com/pieverse_io/status/1984093439194231033",
  AutomataNetwork: "https://x.com/AutomataNetwork/status/1981015929652937039",
  GoPlusSecurity: "https://x.com/GoPlusSecurity/status/1983449081767936322",
  Vana: "https://blog.brevis.network/2025/11/04/brevis-x-vana-enabling-private-data-sovereignty-with-zk-powered-trust/",
  UnifAI: "https://x.com/brevis_zk/status/1984949083048751239",
  YieldNest:
    "https://blog.brevis.network/2025/11/18/yieldnest-launches-incentra-campaign-for-ynrwax-holders/",
  Aster: "https://x.com/brevis_zk/status/1998664061706453142",
  Opinion:
    "https://blog.brevis.network/2025/12/18/brevis-brings-trustless-data-to-opinion-the-future-of-prediction-market-settlement/",
  APRO: "https://blog.brevis.network/2026/01/26/brevis-and-apro-trust-free-oracles-and-trader-privacy-for-prediction-markets/",
  Trendle:
    "https://blog.brevis.network/2026/01/22/brevis-primus-and-trendle-building-verifiable-attention-markets-on-monad/",
  Primus:
    "https://blog.brevis.network/2026/01/22/brevis-primus-and-trendle-building-verifiable-attention-markets-on-monad/",
  USD8: "https://blog.brevis.network/2026/01/20/brevis-and-usd8-trustless-insurance-for-defi/",
  "0xbow":
    "https://blog.brevis.network/2026/01/15/brevis-x-bnb-chain-redefining-privacy-infrastructure-for-web3/",
  BNBChain:
    "https://blog.brevis.network/2026/01/15/brevis-x-bnb-chain-redefining-privacy-infrastructure-for-web3/",
  Cypher: "https://x.com/brevis_zk/status/2011030479399764448",
};
const gasJson = {
  ETHGas:
    "https://blog.brevis.network/2025/12/22/brevis-x-ethgas-exploring-verifiable-gas-abstraction/",
};

function ForthPage() {
  const { isMobile } = useIsMobile();
  const [open, setOpen] = useState(false);
  const [openAI, setOpenAI] = useState(false);
  const [openRWA, setOpenRWA] = useState(false);
  const [hovered] = useState(null);
  const [played, setPlayed] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPlayed(true);
          obs.disconnect();
        }
      },
      { threshold: 0.25 },
    );
    obs.observe(containerRef.current);
    return () => obs.disconnect();
  }, []);

  const settings = {
    duration: 0.8,
    stagger: 0.07,
    animateFrom: "bottom",
    scaleOnHover: true,
    hoverScale: 0.95,
    blurToFocus: false,
    hoverTransition: 0.28,
  };

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: settings.stagger,
      },
    },
  };

  const item = {
    hidden: {
      opacity: 0,
      y: settings.animateFrom === "bottom" ? 80 : -80,
      borderColor: "rgba(43, 48, 59, 0.2)",
      boxShadow: "0px 0px 0px rgba(0,0,0,0)",
    },
    visible: {
      opacity: 1,
      y: 0,
      borderColor: "rgba(22, 122, 255, 0.12)",
      boxShadow: "0px 12px 30px rgba(22,122,255,0.06)",
      transition: {
        duration: settings.duration,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  };

  const cardStyle = (index, base = {}) => {
    const out = { ...base };
    if (settings.blurToFocus && hovered !== null && hovered !== index) {
      out.filter = "blur(3px)";
      out.opacity = 0.72;
      // keep layout stable
      out.transition = "filter 0.18s ease, opacity 0.18s ease";
    }
    return out;
  };

  return (
    <div className="casePage" id="casePage" ref={containerRef}>
      <div className="pageTitle">
        {/* <SplitText
          text="Use Cases"
          className="pageTitle"
          delay={100}
          duration={0.6}
          ease="power3.out"
          splitType="chars"
          from={{ opacity: 0, y: 40 }}
          to={{ opacity: 1, y: 0 }}
          threshold={0.1}
          rootMargin="-100px"
          textAlign="center"
          onLetterAnimationComplete={() => {}}
        /> */}
        Use Cases
      </div>
      <motion.div
        className="casesWrap casesWrapTriple"
        variants={container}
        initial="hidden"
        animate={played ? "visible" : "hidden"}
      >
        <motion.div
          className="caseCard"
          style={cardStyle(0, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Intelligent DeFi }"}
            <img alt="" className="caseIcon" src={caseIcon} />
          </div>
          <div className="cardDes">
            Personalized fees, rewards, and user experiences based on historical
            behavior and market conditions. DEXes, yield aggregators, and
            lending protocols offer volume discounts, loyalty programs, and
            dynamic configurations.
          </div>
          <div className="cardLink">
            <div
              className="cardLinkOut"
              style={{ marginRight: isMobile ? 0 : 20 }}
            >
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["PancakeSwap"], "_blank");
                }}
              >
                PancakeSwap
              </span>
              ]
            </div>
            <div
              className="cardLinkOut"
              style={{ marginRight: isMobile ? 0 : 20 }}
            >
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Uniswap"], "_blank");
                }}
              >
                Uniswap
              </span>
              ]
            </div>
            <div
              className="cardLinkOut"
              style={{ marginRight: isMobile ? 0 : 20 }}
            >
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["MetaMask"], "_blank");
                }}
              >
                MetaMask
              </span>
              ]
            </div>

            <div
              style={{ position: "relative" }}
              onMouseLeave={() => setOpen(false)}
              onMouseEnter={() => setOpen(true)}
            >
              <span
                className="cardLinkText moreLink"
                style={{ paddingLeft: 7 }}
              >
                <img alt="" className="moreTop" src={moreTop} />
                {projects.length} More
                <img alt="" className="moreFooter" src={moreFooter} />
              </span>
              <div
                style={{
                  width: "100%",
                  height: 5,
                  pointerEvents: "none",
                }}
              />
              <AnimatePresence>
                {open && (
                  <motion.div
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.15 }}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "rgba(236, 235, 231, 1)",
                      border: "1px solid rgba(43, 48, 59, 0.8)",
                      zIndex: 99,
                      minWidth: "210px",
                      padding: "6px 0",
                    }}
                  >
                    {projects.map((p) => (
                      <motion.a
                        key={p.name}
                        href={p.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{
                          backgroundColor: "rgba(43, 48, 59, 0.05)",
                        }}
                        style={{
                          display: "block",
                          padding: "6px",
                          textDecoration: "none",
                          color: "rgba(43, 48, 59, 0.8)",
                          fontSize: "16px",
                          width: 200,
                          marginLeft: 5,
                        }}
                      >
                        {p.name}
                      </motion.a>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="caseCard"
          style={cardStyle(1, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ RWA & Stable Token Growth }"}
            <img alt="" className="caseIcon2" src={caseIcon2} />
          </div>
          <div className="cardDes">
            Stablecoin and real-world asset protocols implement continuous
            incentivization with transparent distribution. Rewards based on
            verifiable on-chain activity and participation history.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["OpenEden"], "_blank");
                }}
              >
                OpenEden
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["UsualMoney"], "_blank");
                }}
              >
                Usual Money
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["MetaMaskUSD"], "_blank");
                }}
              >
                MetaMask USD
              </span>
              ]
            </div>

            {/* <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["YieldNest"], "_blank");
                }}
              >
                YieldNest
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["USD8"], "_blank");
                }}
              >
                USD8
              </span>
              ]
            </div> */}
            <div
              style={{ position: "relative" }}
              onMouseLeave={() => setOpenRWA(false)}
              onMouseEnter={() => setOpenRWA(true)}
            >
              <span
                className="cardLinkText moreLink"
                style={{ paddingLeft: 14 }}
              >
                <img alt="" className="moreTop" src={moreTop} />
                {rwaProjects.length} More
                <img alt="" className="moreFooter" src={moreFooter} />
              </span>
              <div
                style={{
                  width: "100%",
                  height: 5,
                  pointerEvents: "none",
                }}
              />
              <AnimatePresence>
                {openRWA && (
                  <motion.div
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.15 }}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "rgba(236, 235, 231, 1)",
                      border: "1px solid rgba(43, 48, 59, 0.8)",
                      zIndex: 99,
                      minWidth: "210px",
                      padding: "6px 0",
                    }}
                  >
                    {rwaProjects.map((p) => (
                      <motion.a
                        key={p.name}
                        href={p.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{
                          backgroundColor: "rgba(43, 48, 59, 0.05)",
                        }}
                        style={{
                          display: "block",
                          padding: "6px",
                          textDecoration: "none",
                          color: "rgba(43, 48, 59, 0.8)",
                          fontSize: "16px",
                          width: 200,
                          marginLeft: 5,
                        }}
                      >
                        {p.name}
                      </motion.a>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      </motion.div>
      <motion.div
        className="casesWrap"
        variants={container}
        initial="hidden"
        animate={played ? "visible" : "hidden"}
      >
        <motion.div
          className="caseCard"
          style={cardStyle(2, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ DEX with Dark Pools }"}
            <img alt="" className="caseIcon3" src={caseIcon3} />
          </div>
          <div className="cardDes">
            Order books and matching engines operate off-chain with L1-level
            security. ZK proofs enable private trading while maintaining
            trustless verification.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [{" "}
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Aster"], "_blank");
                }}
              >
                Aster
              </span>{" "}
              ]
            </div>
          </div>
        </motion.div>
        <motion.div
          className="caseCard"
          style={cardStyle(3, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Cross-chain Interoperability }"}
            <img alt="" className="caseIcon4" src={caseIcon4} />
          </div>
          <div className="cardDes">
            Cross-chain restaking and instant interoperability between rollups
            and L1 blockchains. ZK proofs enable trustless bridging and shared
            security.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [{" "}
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Kernel"], "_blank");
                }}
              >
                Kernel
              </span>{" "}
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [{" "}
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Celer"], "_blank");
                }}
              >
                Celer
              </span>{" "}
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["GG"], "_blank");
                }}
              >
                0G
              </span>
              ]
            </div>
          </div>
        </motion.div>
        <motion.div
          className="caseCard"
          style={cardStyle(3, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Gas Abstraction }"}
            <img alt="" className="caseIcon41" src={caseIcon41} />
          </div>
          <div className="cardDes">
            Transaction fees across rollups and L1 blockchains are calculated
            and settled with cryptographic guarantees. ZK proofs enable
            trust-minimized gas abstraction, removing reliance on centralized
            fee relay infrastructure.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [{" "}
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(gasJson["ETHGas"], "_blank");
                }}
              >
                ETHGas
              </span>{" "}
              ]
            </div>
          </div>
        </motion.div>
      </motion.div>
      <motion.div
        className="casesWrap"
        variants={container}
        initial="hidden"
        animate={played ? "visible" : "hidden"}
      >
        <motion.div
          className="caseCard"
          style={cardStyle(4, { width: "33.333%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Blockchain Bootstrap }"}
            <img alt="" className="caseIcon5" src={caseIcon5} />
          </div>
          <div className="cardDes">
            New blockchains launch sophisticated growth programs with verifiable
            incentive distribution. Ecosystem-wide liquidity and user
            acquisition through transparent ZK-powered mechanisms.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Linea"], "_blank");
                }}
              >
                Linea
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["TAC"], "_blank");
                }}
              >
                TAC
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["UnitsNetwork"], "_blank");
                }}
              >
                Units Network
              </span>
              ]
            </div>
          </div>
        </motion.div>
        <motion.div
          className="caseCard"
          style={cardStyle(5, { width: "33.333%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ 100X Faster L1s }"}
            <img alt="" className="caseIcon6" src={caseIcon6} />
          </div>
          <div className="cardDes">
            Blockchain consensus shifts from network-wide computation to
            single-node proving with distributed verification. Real-time proving
            enables 100x scalability improvements.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Ethereum"], "_blank");
                }}
              >
                Ethereum
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["BNBChain"], "_blank");
                }}
              >
                BNB Chain
              </span>
              ]
            </div>
          </div>
        </motion.div>
        <motion.div
          className="caseCard"
          style={cardStyle(6, { width: "33.333%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Verifiable AI }"}
            <img alt="" className="caseIcon7" src={caseIcon7} />
          </div>
          <div className="cardDes">
            AI applications with privacy-preserving personalization and provable
            model outputs. Data-driven experiences without exposing user data or
            compromising computation integrity.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Kaito"], "_blank");
                }}
              >
                Kaito
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Trust"], "_blank");
                }}
              >
                Trusta
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["KiteAI"], "_blank");
                }}
              >
                Kite AI
              </span>
              ]
            </div>

            <div
              style={{ position: "relative" }}
              onMouseLeave={() => setOpenAI(false)}
              onMouseEnter={() => setOpenAI(true)}
            >
              <span
                className="cardLinkText moreLink"
                style={{ paddingLeft: 14 }}
              >
                <img alt="" className="moreTop" src={moreTop} />
                {aiProjects.length} More
                <img alt="" className="moreFooter" src={moreFooter} />
              </span>
              <div
                style={{
                  width: "100%",
                  height: 5,
                  pointerEvents: "none",
                }}
              />
              <AnimatePresence>
                {openAI && (
                  <motion.div
                    initial={{ opacity: 0, y: -5 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -5 }}
                    transition={{ duration: 0.15 }}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "rgba(236, 235, 231, 1)",
                      border: "1px solid rgba(43, 48, 59, 0.8)",
                      zIndex: 99,
                      minWidth: "210px",
                      padding: "6px 0",
                    }}
                  >
                    {aiProjects.map((p) => (
                      <motion.a
                        key={p.name}
                        href={p.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{
                          backgroundColor: "rgba(43, 48, 59, 0.05)",
                        }}
                        style={{
                          display: "block",
                          padding: "6px",
                          textDecoration: "none",
                          color: "rgba(43, 48, 59, 0.8)",
                          fontSize: "16px",
                          width: 200,
                          marginLeft: 5,
                        }}
                      >
                        {p.name}
                      </motion.a>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      </motion.div>
      <motion.div
        className="casesWrap"
        variants={container}
        initial="hidden"
        animate={played ? "visible" : "hidden"}
      >
        <motion.div
          className="caseCard"
          style={cardStyle(7, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Privacy }"}
            <img alt="" className="caseIcon" src={caseIcon8} />
          </div>
          <div className="cardDes">
            Privacy-preserving computation and confidential data processing with
            ZK proofs. Enable sensitive operations while maintaining data
            confidentiality and verification integrity.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["AutomataNetwork"], "_blank");
                }}
              >
                Automata Network
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Primus"], "_blank");
                }}
              >
                Primus
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["0xbow"], "_blank");
                }}
              >
                0xbow
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["BNBChain"], "_blank");
                }}
              >
                BNB Chain
              </span>
              ]
            </div>
          </div>
        </motion.div>
        <motion.div
          className="caseCard"
          style={cardStyle(8, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Security }"}
            <img alt="" className="caseIcon2" src={caseIcon9} />
          </div>
          <div className="cardDes">
            ZK-verified security assessments and risk analysis for DeFi
            protocols. Trustless security data delivery and verifiable
            compliance checking across blockchain ecosystems.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["GoPlusSecurity"], "_blank");
                }}
              >
                GoPlus Security
              </span>
              ]
            </div>
          </div>
        </motion.div>

        <motion.div
          className="caseCard"
          style={cardStyle(8, { width: "50%" })}
          variants={item}
        >
          <div className="cardTitle">
            {"{ Prediction Markets }"}
            <img alt="" className="caseIcon2" src={caseIcon10} />
          </div>
          <div className="cardDes">
            Prediction markets settle with cryptographic certainty using
            ZK-verified real-world data. Market outcomes resolved through
            provable data authenticity and trustless computation, eliminating
            human validators and subjective oracle consensus.
          </div>
          <div className="cardLink">
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Opinion"], "_blank");
                }}
              >
                Opinion
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["APRO"], "_blank");
                }}
              >
                APRO
              </span>
              ]
            </div>
            <div style={{ marginRight: isMobile ? 0 : 20 }}>
              [
              <span
                className="cardLinkText"
                onClick={() => {
                  window.open(linkJson["Trendle"], "_blank");
                }}
              >
                Trendle
              </span>
              ]
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default ForthPage;
